import React from "react";
import { createTheme } from "@mui/material/styles";
import { Box, Typography } from "@mui/material";
export const themes = {
  // primary: "#4FD1C5",
  primary: "#F2F2F7",
  primaryButton: "#84DEB8",
  primaryIndicator: "#84DEB8", //Indicator ,
  primaryHeader: "#607eeb",
  primaryBlue: "#0C8CE9",
  lightShadow: "#feffff",
  headLine: "#000000",
  whiteColor: "white",
  tableHeader: "#4FD1C5",
  taskBorder: "#E9ECEF",
  taskHeader: "#B6B6B6",
  button: "#00cca3",
  tabIndicator: 1,
  allTap: "#065BAA",
  activeTap: "#149611",
  absentTap: "#FF0000",
  permissionTap: "#8B198D",
  breakTap: "#EC00F1",
  onleaveTap: "#CB680D",
  lateTap: "#09AEB9",
  backgroundShadow: "#D9D9D9",
  cardProjectName: "#3C557A",
  secondryButtonColor: "#9C27B0",
  primaryButtonColor: "#1976D2",
  projectActiveTapColor: "#231F1F",
  activeProject: "#21AB79",
  inactiveProject: "#C35353",
  completedProject: "#F41062",
  holdProject: "#F4CC40",
  formBackground: "#f0f3f5",
  sprintBackground: "#898989",
  workingHours: "#081A51",
  dividerBorder: "#B2B2B5",
  tagBlurColor: "#17285C",
  helperTextColor: "#D32F2F",
  newUser: "#7BDDD3",
  allIconColor: "#a6a6a6",
  shadowColor: "#bcb9bd",
  redColor: "red",
  blueColor: "#34c6eb",
  darkBlue: "#1679ca",
  lightGray: "#a1a9b2",
  buttonBorder: "#D0D5DD",
  colorShadow: "#7D8488",
  showSprintColor: "#715E5E",
  taskBtnBck: "#036EFF",
  proWrkFlwClr: "#351EC3",
  greenColor: "#008000",
  purpleColor: "#800080",
  backgroundColor: "#3FCEC6",
  bgIconColor: "#7D7D7D",
  txtErrorColor: "#DB2F2F",
  btnBackgroundColor: "#8BE1D8",
  lightGreen: "#34eb8c",
  lightGreenD: "#5ae879",
  buttonBackground: "#cccccc",
  sidebarDivider: "#E0E0E0",
  generalSubHeader: "#A2A3A7",
  yellowColor: "#ffcc00",
  lightRedColor: "#ff5d5d",
  lightYellowColor: "#fffd8d",
  balanceColor: "#B79B08",
  lightOrange: "#FF9169",
  white: "#FFFFFF",
  shadowText: "#8C94A3",
  lightBrown: "#d9d9d9",
  leaveBrown: "#9b4c2f",
  backgroundRed: "#f09ca4",
  halfDay: "#6B3E3E",
  loginImage: "#09BD71",
  grayColor: "#3a4855",
  lightBlue: "#bddeff",
  darkPrimary: "#e8e8e8",
  shadowBackGround: "#EFF5F7",
  gradient: "#3f4d7f",
  pinkColor: "#fd71fe",
  downloadIconColor: "#25B7D3",
  darkGray: "#818387",
  closeIcon: "#8E99A4",
  disabledColor: "#f0f0f0",
  disable: "#a3a3c2",
  earlyExit: "#4080bf",
  out: "#8a8a5c",
  planned: "#669999",
  unassigned: "#8c8c8c",
  weekoff: "#ffbb99",
  holiday: "#c6538c",
  darkGreen: "#188c5a",
  editIconColor: "#609cbf",
  miliedRedColor: "#ffcccc",
  whiteSmoke: "#f5f5f5",
  paleGray: "#f0f1ed",
  indogo: "#3f51b5",
  miliedLightGray: "#E5E7EB",
  miliedLightBlue: "#F0F7FF",
  lightGradient: "#EEBD68",
  paleYellow: "#FDE68A",
  mintGreen: "#A7F3D0",
  softSkyBlue: "#BFDBFE",
  lightPink: "#FBCFE8",
  roseBlush: "#FECACA",
  lavender: "#E9D5FF",
  paleAqua: "#D1FAE5",
  babyCoral: "#FDE2E2",
  cream: "#FFF5CC",
  royalBlue: "#1D4ED8",
  babyBlue: "#e3f2fd",
  palepink: "#ffebee",
  pastelPurple: "#f3e5f5",
  palegreen: "#e8f5e8",
  peachtint: "#fff3e0",
  pinkishred: "#ef9a9a",
  lavenderpurple: "#ce93d8",
  freshgreen: "#c8e6c9",
  goldenYellow: "#ffcc02",
  stepActiveColor: "#00D4AA",
  mutedgreen: "#95bf9f",
  softMutedGreen: "#09bd71",
  mutedpurple: "#4f3b5f",
};

export const tableContainerSx = {
  ml: 2,
  mr: 2,
  width: "100%",
  maxHeight: { xs: 150, sm: 300, md: 400, lg: 700, xl: 750 },
};

export const tableContainerSxWithCompany = {
  padding: 1,
  width: "100%",
  maxHeight: { xs: 150, sm: 300, md: 400, lg: 650, xl: 700 },
};

export const cardBorder = {
  borderLeft: `5px solid ${themes?.stepActiveColor}`,
  borderTop: `1px solid ${themes?.stepActiveColor}`,
  borderRight: `1px solid ${themes?.stepActiveColor}`,
  borderBottom: `1px solid ${themes?.stepActiveColor}`,
  borderRadius: 2,
};

export const iconStyle = {
  border: "1px solid #ccc",
  borderRadius: "8px",
  padding: "8px",
};

export const tableHeaderSx = {
  backgroundColor: themes.primary,
  position: "sticky",
  top: -1,
  zIndex: 10,
};

export const optionalAvathar =
  "https://cdn-icons-png.flaticon.com/512/149/149071.png";

export const tableRowSx = {
  "& .MuiTableCell-root": {
    height: "10px",
    padding: "3px 15px",
  },
};

export const tableRowSxTimeline = {
  "& .MuiTableCell-root": {
    height: "10px",
    padding: "8px 15px",
  },
};

export const tableRowSize = {
  cursor: "pointer",
  transition: "background-color 0.3s",
  "& td, & th": {
    padding: "10px 8px",
    lineHeight: 1.2,
  },
  "&:hover": {
    backgroundColor: themes?.primary,
  },
};

export const stickyHeader = {
  backgroundColor: themes.primary,
  position: "sticky",
  top: -1,
  zIndex: 10,
};

export const tableCellFontSize = { xs: 6, sm: 8, md: 10, lg: 12, xl: 15 };

export const sideBarWidth = 280;

export const deleteText = "Delete Confirmation";
export const deactivateText = "Confirm Deactivate";
export const unSavedText = "Unsaved Changes";

export const deleteMessage = (name) =>
  `Are you sure you want to delete ${
    name || "this item"
  }? This action cannot be undone.`;
export const unSavedMessage =
  "You have unsaved changes. Are you sure you want to exit? Your changes will be lost.";

export const headerMessage = (headerName, headerDescription) => {
  return (
    <Box sx={{ paddingLeft: 2, marginTop: 2 }}>
      <Typography variant="h5" sx={{ fontWeight: 600, mb: 1 }}>
        {headerName}
      </Typography>
      <Typography variant="body2" color="text.secondary">
        {headerDescription}
      </Typography>
    </Box>
  );
};

export const theme = createTheme({
  palette: {
    primary: {
      main: "#00D4AA",
    },
    secondary: {
      main: "#6c757d",
    },
  },
  typography: {
    fontFamily:
      '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
  },
});

export const drawerStyle = {
  "& .MuiDrawer-paper": {
    width: "680px",
    maxWidth: "90vw",
    backgroundColor: themes?.themes?.whiteColor,
  },
};

export const drawerMediumWidth = {
  "& .MuiDrawer-paper": {
    width: "900px",
    maxWidth: "90vw",
    backgroundColor: themes?.themes?.whiteColor,
  },
};

export const switchStyle = {
  display: "flex",
  justifyContent: "space-between",
  ml: 2,
  mb: 2,
};

export const displayFlexItem = {
  display: "flex",
  alignItems: "center",
  gap: 1,
};

export const doubleArrowStyle = {
  color: themes?.grayColor,
  "&:hover": {
    backgroundColor: themes?.whiteColor,
  },
};

export const parentBoxStyle = {
  height: "100vh",
  display: "flex",
  flexDirection: "column",
};

export const childBoxStyle = {
  display: "flex",
  flexDirection: "column",
  gap: 3,
  ml: 1.5,
};

export const childBoxStyleSpaceBetween = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  px: 1,
};

export const childBoxStyleWithColor = {
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  padding: 1,
  backgroundColor: themes?.primary,
};

export const infoStyle = {
  variant: "body2",
  color: "text.secondary",
  sx: { mb: 0.5 },
};

export const toAlignEnd = {
  display: "flex",
  gap: 2,
  justifyContent: "flex-end",
};

export const deleteIconStyle = {
  color: themes?.redColor,
  backgroundColor: themes?.primary,
  borderRadius: "50%",
  "&:hover": { backgroundColor: themes?.primary },
  mt: 0.5,
};

export const BackArrowStyle = {
  border: "1px solid",
  borderColor: "divider",
  borderRadius: 2,
  ml: 2,
  mt: 1.5,
  backgroundColor: themes?.whiteColor,
};

export const BoxStyle = {
  flexGrow: 1,
  p: 2,
  minWidth: 0,
  backgroundColor: "#f5f5fd",
  transition: "all 0.3s ease",
};

export const editIconStyle = {
  color: themes?.greenColor,
  backgroundColor: themes?.primary,
  borderRadius: "50%",
  "&:hover": { backgroundColor: themes?.primary },
  mr: 2,
  mt: 0.5,
};

export const chipColors = {
  "Shift Penalty": {
    bg: "#E0F2FE",
    text: "#0369A1",
  },
  "Break Penalty": {
    bg: "#E8EEFF",
    text: "#102BA2",
  },
  "Absence Penalty": {
    bg: "#FEE2E2",
    text: "#FA4A4A",
  },
  "Permission Penalty": {
    bg: "#F3E8FF",
    text: "#760F81",
  },
};

export const scrollTop = (tableContainerRef) => {
  if (tableContainerRef.current) {
    tableContainerRef.current.scrollTop = 0;
  }
};

export const sideBarIcon = {
  color: themes.redColor,
  stroke: themes.redColor,
  strokeWidth: 1.5,
  fill: "transparent",
  opacity: 0.8,
};

export const getOrdinal = (n) => {
  if (!n) return "";
  const s = ["th", "st", "nd", "rd"];
  const v = n % 100;
  return n + (s[(v - 20) % 10] || s[v] || s[0]);
};

export const StatusBadge = ({ color, label }) => {
  // const color = statusColors[statusId] || "#BDBDBD";

  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
      <Box
        sx={{
          width: 10,
          height: 10,
          borderRadius: "50%",
          backgroundColor: color,
        }}
      />
      <Typography variant="body2">{label}</Typography>
    </Box>
  );
};

export const getStatusFlow = (expandedData) => ({
  Pending: [
    ...(!expandedData?.hideAppliedByInStatusFlow
      ? [
          {
            status: "applied",
            user: expandedData?.applied_by,
            date: expandedData?.applied_on,
          },
        ]
      : []),
    ...(expandedData?.reason || expandedData?.applied_reason
      ? [
          {
            status: "reason",
            user: expandedData?.reason || expandedData?.applied_reason,
          },
        ]
      : []),
  ],

  Approved: [
    ...(!expandedData?.hideAppliedByInStatusFlow
      ? [
          {
            status: "applied",
            user: expandedData?.applied_by,
            date: expandedData?.applied_on,
          },
        ]
      : []),
    ...(expandedData?.reason || expandedData?.applied_reason
      ? [
          {
            status: "reason",
            user: expandedData?.reason || expandedData?.applied_reason,
          },
        ]
      : []),
    {
      status: "approved",
      user: expandedData?.approved_by,
      date: expandedData?.approved_at ?? expandedData?.approved_on,
    },
  ],

  Completed: [
    ...(!expandedData?.hideAppliedByInStatusFlow
      ? [
          {
            status: "applied",
            user: expandedData?.applied_by,
            date: expandedData?.applied_on,
          },
        ]
      : []),
    ...(expandedData?.reason || expandedData?.applied_reason
      ? [
          {
            status: "reason",
            user: expandedData?.reason || expandedData?.applied_reason,
          },
        ]
      : []),
    {
      status: "approved",
      user: expandedData?.approved_by,
      date: expandedData?.approved_at ?? expandedData?.approved_on,
    },
    {
      status: "completed",
      user: expandedData?.completed_by,
      date:
        expandedData?.completed_at ??
        expandedData?.completed_on ??
        expandedData?.completed_date,
    },
  ],

  Rejected: [
    ...(!expandedData?.hideAppliedByInStatusFlow
      ? [
          {
            status: "applied",
            user: expandedData?.applied_by,
            date: expandedData?.applied_on,
          },
        ]
      : []),
    ...(expandedData?.reason || expandedData?.applied_reason
      ? [
          {
            status: "reason",
            user:
              expandedData?.reason || expandedData?.applied_reason
                ? expandedData?.reason || expandedData?.applied_reason
                : "N/A",
          },
        ]
      : []),
    {
      status: "rejected",
      user: expandedData?.rejected_by,
      date: expandedData?.rejected_at,
    },
    ...(expandedData?.rejected_reason
      ? [
          {
            status: "rejectReason",
            user: expandedData?.rejected_reason
              ? expandedData?.rejected_reason
              : "N/A",
          },
        ]
      : []),
  ],

  Cancelled: [
    ...(!expandedData?.hideAppliedByInStatusFlow
      ? [
          {
            status: "applied",
            user: expandedData?.applied_by,
            date: expandedData?.applied_on,
          },
        ]
      : []),
    ...(expandedData?.reason || expandedData?.applied_reason
      ? [
          {
            status: "reason",
            user:
              expandedData?.reason || expandedData?.applied_reason
                ? expandedData?.reason || expandedData?.applied_reason
                : "N/A",
          },
        ]
      : []),
    // A request cancelled after being Approved (rather than cancelled
    // straight out of Pending) still has an approver — show that step so
    // the flow reads Applied -> Approved -> Cancelled instead of skipping
    // straight from Applied to Cancelled.
    ...(expandedData?.approved_by
      ? [
          {
            status: "approved",
            user: expandedData?.approved_by,
            date: expandedData?.approved_at ?? expandedData?.approved_on,
          },
        ]
      : []),
    {
      status: "cancelled",
      user: expandedData?.cancelled_by,
      date: expandedData?.cancelled_at,
    },
    ...(expandedData?.cancelled_reason
      ? [
          {
            status: "cancelReason",
            user: expandedData?.cancelled_reason || "N/A",
          },
        ]
      : []),
  ],
});

export const StatusType = (type, bg) => {
  return {
    background: bg || "#ccc",
    // color: colorSet.color || "#000",
    padding: "4px 10px",
    borderRadius: "6px",
    fontSize: "12px",
    display: "inline-block",
  };
};

export const validateFormulaPattern = (expr) => {
  if (!expr) return false;
  expr = expr.toUpperCase().replace(/\s+/g, "");
  // Allow: alphanumeric, operators (+,-,*,/), comparison operators (<=,>=,<,>,==,!=), parentheses, commas, decimal points, and percentage
  if (!/^[A-Z0-9.+\-*/(),<>=!%]+$/.test(expr)) return false;
  let stack = 0;
  for (const c of expr) {
    if (c === "(") stack++;
    if (c === ")") stack--;
    if (stack < 0) return false;
  }
  if (stack !== 0) return false;
  if (/[*+/-]{2,}/.test(expr.replace(/^-/, ""))) return false;
  if (/[A-Z]+[0-9]+[A-Z]+/.test(expr)) return false;
  if (/[0-9]+[A-Z]+/.test(expr)) return false;
  if (/[A-Z]+[0-9]+/.test(expr)) return false;
  if (/^[*/+]/.test(expr) || /[*/+]$/.test(expr)) return false;

  return true;
};

export const adminRoleName = "Super Admin";
export const supportLabel = "Support Admin";
export const teamLeadLabel = "Team Lead";

export const nameLength = 100;

export const weeks = [
  {
    id: 1,
    weeks: "One Week",
    label: "One Week",
  },
  {
    id: 2,
    weeks: "Two Weeks",
    label: "Two Weeks",
  },
  {
    id: 3,
    weeks: "Three Weeks",
    label: "Three Weeks",
  },
  {
    id: 4,
    weeks: "Four Weeks",
    label: "Four Weeks",
  },
  {
    id: 5,
    weeks: "Five Weeks",
    label: "Five Weeks",
  },
  {
    id: 6,
    weeks: "Six Weeks",
    label: "Six Weeks",
  },
  {
    id: 7,
    weeks: "Custom",
    label: "Custom",
  },
];

export const taskPriority = [
  {
    id: 1,
    priority: "Low",
    label: "Low",
  },
  {
    id: 2,
    priority: "Medium",
    label: "Medium",
  },
  {
    id: 3,
    priority: "High",
    label: "High",
  },
];

export const taskTypeArr = [
  {
    id: 1,
    label: "All",
  },
  {
    id: 2,
    label: "Parent Task",
  },
  {
    id: 3,
    label: "Child Task",
  },
];

export const toastContainerStyle = {
  width: "500px",
  margin: "0 auto",
  position: "fixed",
  top: "0",
  left: "0",
  right: "0",
};

export const changePassword = {
  successType: "success",
  successAlert:
    "Password changed. Please log out and log in again with your new password.",
  failureType: "danger",
  failureAlert: "Incorrect current password. Please try again.",
};
export const defaultLead = null;
export const selectedField = null;
export const buttonAndTableHeaderColor = {
  button: "#8BE1D8",
  TableHeader: "#4FD1C5",
  formHeader: "#4FD1C5",
};

export const subMenuIndicator = {
  indicator: "#C1EEEA",
};

export const gender = [
  { id: 1, gender: "Male", label: "Male" },
  { id: 2, gender: "Female", label: "Female" },
];

export const country = [
  { id: 1, country: "Oman", label: "Oman" },
  {
    id: 2,
    country: "India",
    label: "India",
  },
];

export const countryState = [
  { id: 1, stateName: "Tamil Nadu", countryId: 2 },
  {
    id: 2,
    stateName: "Punjab",
    label: "Punjab",
    countryId: 2,
  },
  {
    id: 3,
    stateName: "Kerala",
    label: "Kerala",
    countryId: 2,
  },
  {
    id: 4,
    stateName: "Al Buraimi",
    label: "Al Buraimi",
    countryId: 1,
  },
  {
    id: 5,
    stateName: "Muscat",
    label: "Muscat",
    countryId: 1,
  },
  {
    id: 6,
    stateName: "Muscat",
    label: "Muscat",
    countryId: 1,
  },
];

//User management  search keys

export const employeeCardKeys = ["user_name", "designation"];
export const employeeListKeys = [
  "user_name",
  "user_code",
  "department",
  "employment_type",
  "company_name",
  "designation",
  "department_lead_name",
  "system_access",
  "status",
  "type",
];
export const teamCardKeys = ["team_name", "team_lead_name", "proxy_name"];
export const teamListKeys = [
  "team_name",
  "team_lead_name",
  "email",
  "proxy_name",
  "created",
];

//Permission Type on Leave apply screen

export const PermissionType = [
  {
    id: 1,
    permissionType: "Bus Late",
  },
  {
    id: 2,
    permissionType: "Medical Emergency ",
  },
  {
    id: 3,
    permissionType: "Others",
  },
];

export const statusType = [
  {
    name: "All",
  },
  { name: "Active" },

  {
    name: "Inactive",
  },
];

export const siteSettingsEditToastMessage = {
  editMessage: "Site status updated.",
};

export const leaveTaxYear = [
  {
    year: "2023-2024",
    label: "2023-2024",
    yearDate: "2023-2024 (01/04/2023 - 31/03/2024)",
  },
  {
    year: "2024-2025",
    label: "2024-2025",
    yearDate: "2024-2025 (01/04/2024 - 31/03/2025)",
  },
  {
    year: "2025-2026",
    label: "2025-2026",
    yearDate: "2025-2026 (01/04/2025 - 31/03/2026)",
  },
  {
    year: "2026-2027",
    label: "2026-2027",
    yearDate: "2026-2027 (01/04/2026 - 31/03/2027)",
  },
];

export const dateLabels = [
  {
    dateLabel: "This week",
    label: "This week",
  },
  {
    dateLabel: "Last week",
    label: "Last week",
  },
  {
    dateLabel: "This month",
    label: "This month",
  },
  {
    dateLabel: "Last month",
    label: "Last month",
  },
  {
    dateLabel: "This year",
    label: "This year",
  },
  {
    dateLabel: "Last year",
    label: "Last year",
  },
  {
    dateLabel: "Custom",
    label: "Custom",
  },
];

export const dateFormat = "DD-MM-YYYY";
export const yearMonth = "YYYY-MM-DD";
//Project screen filter

export const filterProject = [
  "projectname",
  "clientName",
  "project_lead_name",
  "projectType",
  "status",
  "completed_tasks",
  "total_tasks",
  "date",
];

export const essPermissions = [
  "status",
  "date",
  "start_time",
  "end_time",
  "total_time",
];

export const essApplyLeave = [
  "leave_type",
  "from_date",
  "to_date",
  "business_days",
  "status",
  "description",
];

export const clientFilterKey = [
  "clientname",
  "clientid",
  "address",
  "gstnumber",
  "email",
  "phonenumber",
];

export { defaultAllSelection } from "./selections";

export const leaveTypeColors = {
  Vacation: "#8272C0",
  Sick: "#F46070",
  Casual: "#EA6EE4",
  Bereavement: "#348A9C",
};

export const leaveFilterKey = [
  "user_name",
  "role",
  "total_leave",
  "planned_leave",
  "taken_leave",
  "available_leave",
];

export const attendanceFilterList = [
  "department_name",
  "department_lead_name",
  "email",
  "proxy_name",
  "created",
];

export const attendanceFilterCard = [
  "department_name",
  "members_count",
  "check_in_count",
];

export const rejectedFilter = [
  "username",
  "department_name",
  "title",
  "option",
  "from_date",
  "to_date",
  "business_days",
  "approver_name",
  "description",
];

export const administrationList = [
  "department_name",
  "department_lead_name",
  "email",
  "proxy_name",
  "username",
  "department_member_name",
  "date_of_join",
  "phonenumber",
  "id",
  "created",
];

export const administrationCard = [
  "department_name",
  "members_count",
  "check_in_count",
];

export const administrationCompanies = [
  "companyname",
  "company_code",
  "gstnumber",
  "email",
  "phonenumber",
  "address",
  "system_access",
  "isactive",
  "isprimary",
];

export const pendingFilter = [
  "username",
  "department_name",
  "business_days",
  "from_date",
  "to_date",
];

export const essLeaveFilter = [
  "leave_type",
  "from_date",
  "to_date",
  "business_days",
  "status",
];

export const essPermissionFilter = [
  "permission_type",
  "date",
  "start_time",
  "end_time",
  "status",
];

export const hrmsEmployeeFliter = [
  "user_name",
  "user_code",
  "employee_id",
  "email",
  "status",
];

export const individualTaskList = [
  "task_code",
  "due_date",
  "taskname",
  "task_owner.username",
  "current_assignee.username",
  "work_flow_status.name",
  "priority.name",
];
export const projectDashboard = [
  "sprints.name",
  "sprints.description",
  "sprints.start_date",
  "sprints.end_date",
  "sprints.status",
  "sprints.total_tasks",
  "sprints.completed_tasks",
];
export const projectMyTaskList = [
  "taskname",
  "task_code",
  "project.projectname",
  "sprint.name",
  "work_flow_status.name",
  "priority.name",
  "due_date",
];

export const sprintTaskDetails = [
  "task_code",
  "taskname",
  "task_owner.username",
  "total_time",
  "due_date",
  "priority.name",
  "work_flow_status.name",
];

export const essMyLeaves = [
  "leave_type",
  "from_date",
  "description",
  "business_days",
];

export const leaveGroupMasterData = [
  "leave_type",
  "leave_per_period",
  "user_name",
  "email",
  "user_code",
];

export const masterUserData = ["user_code", "user_name", "email"];

export const leaveTypeHrms = [
  "leave_type",
  "leave_per_period",
  "can_apply_beyond_balance",
];
export const sitesettingsTeamZone = [
  "location_name",
  "address",
  "radius",
  "tag",
  "username",
  "location_status",
];
export const hrmsEmployee = ["user_name", "employee_id", "email"];
export const userGroupNameFilter = ["name", "users_count"];

export const leavePeriodHrms = [
  "name",
  "period_start",
  "period_end",
  "leave_crediting_day",
];

export const punchInDetails = ["username", "punch_in_count"];

export const leaveGroupHrms = [
  "name",
  "leave_type",
  "leave_per_period",
  "user_name",
  "email",
  "user_code",
];

export const IndividualLeaveGroup = [
  "effective_from",
  "effective_to",
  "last_credited_date",
  "leave_types.name",
  "version",
];

export const paymentBank = [
  "bank_name",
  "nick_name",
  "bank_account_number",
  "bank_branch",
  "bank_ifsc_code",
];

export const filterShiftGrp = [
  "id",
  "name",
  "shift_category_id",
  "shift_category_name",
  "departments",
  "department_count",
  "group_user_count",
];

export const filterShiftGrpMem = [
  "department_id",
  "department_name",
  "employee_id",
  "id",
  "shift_category_id",
  "shift_category_name",
  "username",
];

export const filterShiftAsgn = [
  "shift_assignment_id",
  "name",
  "shift_cycle",
  "start_date",
  "end_date",
  "no_of_cycle",
  "total_period",
  "status",
];

export const leaveCreditingShedule = [
  { label: "Monthly" },
  { label: "Quarterly" },
  { label: "Half Yearly" },
  { label: "Annually" },
];

export const leaveAvailabilityPeriod = [
  { label: "1 Month" },
  { label: "2 Month" },
  { label: "3 Month" },
  { label: "4 Month" },
  { label: "5 Month" },
  { label: "6 Month" },
  { label: "7 Month" },
  { label: "8 Month" },
  { label: "9 Month" },
  { label: "10 Month" },
];

export const checkInPolicyDetails = [
  { id: 1, label: "First In", policy: "first_in" },
  { id: 2, label: "Last In", policy: "last_in" },
];
export const checkOutPolicyDetails = [
  { id: 1, label: "First Out", policy: "first_out" },
  { id: 2, label: "Last Out", policy: "last_out" },
];

//Reports
export const reportNames = [
  // {
  //   label: "Summarized working hours",
  // },
  {
    label: "Detailed working hours",
  },
  {
    label: "Attendance Anomalies Report",
  },
  {
    label: "Daily Report",
  },
  {
    label: "Overtime Report",
  },
  {
    label: "Punch details",
  },
  // {
  //   label: "Late Report",
  // },
  {
    label: "Leave and Permission Reports",
  },
  {
    label: "Employee Attendance Report",
  },
  {
    label: "Workforce Status Report",
  },
  // {
  //   label: "Working Hours Report",
  // },
  {
    label: "Device Status Report",
  },
];

export const reports = [
  {
    id: 1,
    label: "Summarized working hours",
  },
  {
    id: 2,
    label: "Detailed working hours",
  },
  {
    id: 3,
    label: "Punch Entry",
  },
  {
    id: 4,
    label: "Break",
  },
  {
    id: 5,
    label: "Adjustment Entry",
  },
  {
    id: 6,
    label: "Working Hours",
  },
  {
    id: 7,
    label: "Time card",
  },
  {
    id: 8,
    label: "Raw Punch Entry",
  },
];

export const AnomalyRepStatus = [
  {
    id: 1,
    label: "All",
  },
  {
    id: 2,
    label: "Missing",
  },
  {
    id: 3,
    label: "Late",
  },
  {
    id: 4,
    label: "Absent",
  },
];

export const employee_use = [
  {
    id: 1,
    label: "Company accommodation",
  },
  {
    id: 2,
    label: "Company transport",
  },
  {
    id: 3,
    label: "Own transport",
  },
];

export const maritial_status = [
  {
    id: 1,
    label: "Single",
  },
  {
    id: 2,
    label: "Married",
  },
];

export const gender_type = [
  {
    id: 1,
    label: "Male",
  },
  {
    id: 2,
    label: "Female",
  },
];

export const salaryType = [
  {
    id: 1,
    label: "Daily",
  },
  {
    id: 2,
    label: "Weekly",
  },
  {
    id: 3,
    label: "Monthly",
  },
];

// `label` is the display text shown in the Reports list row (unchanged, and
// still what PayrollReports/index.js's renderComponent switches on via
// reportName state). `reportName` is the canonical sub_module_name this
// report is granted under in the live product/access/provisioning payload's
// Payroll > Reports module — used only for the viewer-permission check that
// decides whether the row is shown at all, same pattern as
// TeamZone/Reports/index.js's reportRegistry reportName field.
export const payrollReports = [
  {
    id: 1,
    label: "Salary Statement",
    reportName: "Salary Statement Report",
  },
  {
    id: 2,
    label: "Employees' State Insurance (ESI)",
    reportName: "ESI Report",
  },
  {
    id: 3,
    label: "Employees' Provident Fund (EPF)",
    reportName: "EPF Report",
  },
  {
    id: 4,
    label: "Employees' Bank Details",
    reportName: "Employee Bank Details",
  },
  {
    id: 5,
    label: "Overtime (OT)",
    reportName: "OT Report",
  },
];

export const projectReports = [
  {
    id: 1,
    label: "Project Task",
  },
  {
    id: 2,
    label: "User Task",
  },
  {
    id: 3,
    label: "Inprogress Task",
  },
];

export const WorkingHours = [
  {
    id: 1,
    label: "Shift Hours",
  },
  {
    id: 2,
    label: "Working Hours",
  },
];

export const ShiftGradeShift = [
  {
    id: 1,
    label:
      "Calculate working hour as per shift grade . No changes in working hour calculations",
  },
  {
    id: 2,
    label:
      "Adjust the shift hours if the alotted working hour is varies with Grade working hours",
  },
  {
    id: 3,
    label:
      "Adjust the shift hours if the alotted working hour is more than the grade working hours",
  },
  {
    id: 4,
    label:
      "Adjust the shift hours if the alotted working hour is less than the grade working hours",
  },
];

export const textFontSize = {
  formHeaderText: 20,
};

export const timeLineLabelList = [
  {
    id: 1,
    label: "All",
  },
  {
    id: 2,
    label: "Present",
  },
  {
    id: 3,
    label: "Absent",
  },
  {
    id: 4,
    label: "Leave",
  },
  {
    id: 5,
    label: "Late Entry",
  },
  {
    id: 6,
    label: "Overtime",
  },
  {
    id: 7,
    label: "Early Exit",
  },
  {
    id: 8,
    label: "Half Day",
  },

  {
    id: 9,
    label: "Permission",
  },
  {
    id: 10,
    label: "Missing",
  },

  {
    id: 11,
    label: "Holiday",
  },
  {
    id: 12,
    label: "Week Off",
  },
  {
    id: 13,
    label: "Unassigned",
  },
  {
    id: 14,
    label: "Shift Planned",
  },
  {
    id: 15,
    label: "Not Joined",
  },
  {
    id: 16,
    label: "Inactive",
  },
];

// export const brightColorCalendar = {
//   textField: {
//     size: "small",
//     width: "60%",
//     sx: {
//       "& .Mui-disabled": {
//         opacity: 1,
//         WebkitTextFillColor: themes.headLine,
//       },
//     },
//     inputProps: {
//       readOnly: true,
//     },
//   },
// };

export const brightColorCalendar = {
  textField: {
    size: "small",
    width: "60%",
    sx: {
      "& .Mui-disabled": {
        opacity: 1,
        WebkitTextFillColor: "#000", // Or use `themes.headLine`
      },
    },
    inputProps: {
      readOnly: true,
      onKeyDown: (e) => {
        const blockedKeys = ["ArrowUp", "ArrowDown"];
        if (blockedKeys.includes(e.key)) {
          e.preventDefault();
          e.stopPropagation(); // prevent MUI internal handling
        }
      },
    },
  },
};

export const brightColorTimePicker = {
  textField: {
    size: "small",
    width: 15,
    sx: {
      "& .Mui-disabled": {
        // color: themes.headLine,
        opacity: 1,
        WebkitTextFillColor: themes.headLine,
      },
    },
  },
};

export const subHeaderStyle = {
  fontWeight: 700,
  color: "#00D4AA",
  fontSize: 17,
};

export const pathAndProducts = [
  {
    pathname: "monitoring",
    productname: "Monitoring",
  },
  {
    pathname: "myzone",
    productname: "My Workspace",
  },
  {
    pathname: "teamzone",
    productname: "Team Workspace",
  },
  {
    pathname: "payroll",
    productname: "Payroll",
  },
  {
    pathname: "project",
    productname: "Projects",
  },
  {
    pathname: "administration",
    productname: "Administration",
  },
  {
    pathname: "hrzone",
    productname: "People",
  },
  {
    pathname: "crm",
    productname: "CRM",
  },
  {
    pathname: "operations",
    productname: "Operations",
  },
  {
    pathname: "support",
    productname: "System Configuration",
  },
];

export const pathAndProductsScreen = [
  {
    pathname: "components",
    productname: "Components",
  },
  {
    pathname: "operations",
    productname: "Operations",
  },
  {
    pathname: "earning",
    productname: "Earnings",
  },
  {
    pathname: "deductions",
    productname: "Deductions",
  },

  {
    pathname: "processing",
    productname: "Payroll Processing",
  },
  {
    // Payroll > Configuration flyout (/admin/payroll/configuration/<item>);
    // the row's backend name is still "Settings".
    pathname: "configuration",
    productname: "Settings",
  },
  {
    // Payroll > Disbursement flyout (/admin/payroll/disbursement/<item>).
    pathname: "disbursement",
    productname: "Disbursement",
  },
  {
    // Payroll > Pay Inputs flyout (/admin/payroll/pay-inputs/<item>); the
    // row's backend name is still "Components".
    pathname: "pay-inputs",
    productname: "Components",
  },
  {
    // Payroll > Pay Processing flyout (/admin/payroll/pay-processing/<item>);
    // the row's backend name is still "Operations".
    pathname: "pay-processing",
    productname: "Operations",
  },
  {
    // Real backend module_name is "Settings" — see PayRoll/Configuration/PayrollConfiguration/index.js
    // for the fuller history of this string being wrong everywhere it was
    // used for this screen (first "Configuration", then "Setup").
    pathname: "setup",
    productname: "Settings",
  },

  {
    pathname: "apply",
    productname: "My Request",
  },
  {
    pathname: "home",
    productname: "Home",
  },
  {
    pathname: "calendar",
    productname: "Calendar",
  },
  {
    pathname: "myleaves",
    productname: "My Leaves",
  },
  {
    pathname: "myshift",
    productname: "Shift",
  },
  {
    pathname: "status",
    productname: "Home",
  },
  {
    pathname: "myworkinghours",
    productname: "My Attendance",
  },
  {
    pathname: "payslip",
    productname: "Payslip",
  },
  {
    pathname: "eodreport",
    productname: "EOD Report",
  },
  {
    pathname: "settings",
    productname: "Settings",
  },
  {
    pathname: "crm-settings",
    productname: "Settings",
  },
  {
    pathname: "dashboard-v2",
    productname: "Dashboard",
  },
  {
    pathname: "notification-settings",
    productname: "Notification Settings",
  },
  {
    pathname: "support-contacts",
    productname: "Support & Contacts",
  },
  {
    pathname: "cauver-contact",
    productname: "Cauver Contact",
  },
  {
    pathname: "system-punch-processing",
    productname: "System Punch Processing",
  },
  {
    pathname: "organisation",
    productname: "Organisation",
  },
  // Administration > Organisation nested rows. "contacts" and "settings"
  // already have entries in this list that match those row names.
  {
    pathname: "details",
    productname: "Organisation Details",
  },
  {
    pathname: "devices",
    productname: "Devices",
  },
  {
    pathname: "loans",
    productname: "Loans",
  },
  {
    pathname: "employee",
    productname: "Payroll Employee",
  },
  {
    pathname: "run",
    productname: "Run Payroll",
  },
  {
    pathname: "reports",
    productname: "Reports",
  },
  {
    // Payroll > Statutory flyout (/admin/payroll/statutory/<item>), so the
    // sidebar highlights the Statutory row on those pages.
    pathname: "statutory",
    productname: "Statutory",
  },
  {
    pathname: "clients",
    productname: "Clients",
  },
  {
    pathname: "project-management",
    productname: "Projects",
  },
  {
    pathname: "dashboard",
    productname: "Projects",
  },
  {
    pathname: "mytask",
    productname: "Tasks",
  },
  {
    pathname: "report",
    productname: "Reports",
  },
  {
    pathname: "companies",
    productname: "Companies",
  },
  {
    pathname: "sites",
    productname: "Sites",
  },
  {
    pathname: "role",
    productname: "Roles & User Group",
  },
  {
    pathname: "departments",
    productname: "Departments",
  },
  {
    pathname: "department",
    productname: "Departments",
  },
  {
    pathname: "shift",
    productname: "Shift",
  },
  {
    pathname: "user",
    productname: "Users",
  },
  {
    pathname: "create",
    productname: "Users",
  },
  {
    pathname: "edit-user",
    productname: "Users",
  },
  {
    pathname: "create_new",
    productname: "Employee",
  },
  {
    pathname: "employees",
    productname: "Employee",
  },
  {
    pathname: "existing",
    productname: "Employee",
  },
  {
    pathname: "timeoff",
    productname: "LMS",
  },
  {
    // People > Master's sidebar row links straight to
    // /admin/hrzone/master/designation (and its sibling
    // /admin/hrzone/master/employment/type both share the "master"
    // segment at parts[3]). This entry was missing
    // entirely, so Sidebar's isAccessibleSubmenu lookup (index.js's
    // matchSubmenu) always came back undefined here and the "Master" row
    // never matched submenu.name === isAccessibleSubmenu -- it never got
    // the active/selected highlight no matter which Master screen you were
    // actually on.
    pathname: "master",
    productname: "Master",
  },
  {
    pathname: "salaryconfig",
    productname: "Salary Configuration",
  },
  {
    // Payroll > Salary flyout (/admin/payroll/salary/<item>).
    pathname: "salary",
    productname: "Salary Configuration",
  },

  {
    pathname: "worksessions",
    productname: "Work Sessions",
  },
  {
    pathname: "siterounds",
    productname: "Site Rounds",
  },
  {
    pathname: "approve",
    productname: "Approvals",
  },
  {
    pathname: "attendance",
    productname: "Attendance",
  },
  {
    pathname: "leave-summary",
    productname: "Leave Balances",
  },
  {
    pathname: "plan-shift",
    productname: "Rosters",
  },
  {
    pathname: "sprint",
    productname: "Projects",
  },
  {
    pathname: "bulk",
    productname: "Employee",
  },
  {
    pathname: "attendances",
    productname: "Attendance",
  },
  {
    pathname: "admin",
    productname: "Product Control",
  },
  {
    pathname: "edit",
    productname: "Employee",
  },
  {
    pathname: "task",
    productname: "Projects",
  },
  {
    pathname: "payout",
    productname: "Payout",
  },
  {
    pathname: "contacts",
    productname: "Contacts",
  },
  {
    pathname: "agent",
    productname: "Dashboard",
  },
  {
    pathname: "policy",
    productname: "Policy",
  },
  {
    pathname: "reminder",
    productname: "Reminders",
  },
  {
    pathname: "hr-shift",
    productname: "Shift",
  },
  {
    pathname: "eodreport",
    productname: "EOD Report",
  },
  {
    pathname: "incentive",
    productname: "Incentive",
  },
  {
    pathname: "crm report",
    productname: "Reports",
  },
  {
    pathname: "payment-bank",
    productname: "Payment Bank",
  },
  {
    pathname: "payrun-cycle",
    productname: "Payrun Cycle",
  },
  {
    pathname: "payroll-group",
    productname: "Payroll Group",
  },
  {
    pathname: "rounding-rule",
    productname: "Rounding Rule",
  },
  {
    pathname: "payslip",
    productname: "Payslip",
  },
  {
    pathname: "daily-calculation-basis",
    productname: "Daily Calculation Basis",
  },
];

export const iconButtonStyle = {
  backgroundColor: "action.hover",
  borderRadius: "50%",
  border: "1px solid",
  borderColor: "divider",
  color: "text.primary",
  opacity: 1,
  transition: "none",
  "&.Mui-disabled": {
    backgroundColor: "action.hover",
    color: "text.primary",
    opacity: 1,
  },
  "&:hover": { backgroundColor: "action.hover" },
};
